import { ColorSchemeName } from "react-native";
import * as AppConsts from "@/utilities/AppConsts";

interface IColors {
  text: string,
  background: string,
  tint: string,
  tabIconDefault: string,
  tabIconSelected: string,
};

const LIGHT : IColors = {
  text: '#000',
  background: "#ffffff",
  tint: AppConsts.COLOR2,
  tabIconDefault: AppConsts.COLOR2,
  tabIconSelected: AppConsts.COLOR2,
};

const DARK : IColors = {
  //text: '#fff',
  text: '#000',
  background: "#ffffff",
  tint: AppConsts.COLOR2,
  tabIconDefault: AppConsts.COLOR2,
  tabIconSelected: AppConsts.COLOR2,
};

function getColors(colorScheme: ColorSchemeName = 'light') : IColors {
  if (colorScheme == 'dark') {
    return DARK;
  } else {
    return LIGHT;
  }
}

export default getColors;
